import { gql, useQuery } from '@apollo/client';
import {
  DateField,
  FunctionField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import ReactJson from 'react-json-view';
import CloudFrontImageField from 'src/components/CloudFrontImageField';

const GET_ANALYSIS_QUEUE = gql`
  query GetAnalysisQueue($formSubmissionId: Int!) {
    analysis_queue(where: { form_submission_id: { _eq: $formSubmissionId } }, limit: 1) {
      id
      request
      form_submission_id
    }
  }
`;

export const AnalysisQueueImage = () => {
  const record = useRecordContext();
  const translate = useTranslate();

  const { data, loading, error } = useQuery(GET_ANALYSIS_QUEUE, {
    variables: { formSubmissionId: record?.id },
    skip: !record?.id,
  });

  if (loading) return <div>{translate('ra.notification.loading')}</div>;
  if (error) return <div>画像の読み込みエラー</div>;

  const analysisQueue = data?.analysis_queue?.[0];
  if (!analysisQueue) return <div>分析キューが見つかりません</div>;

  // If request is a string (image key), use it directly
  if (typeof analysisQueue.request === 'string') {
    return <CloudFrontImageField source="request" record={analysisQueue} />;
  }

  // If request is an object with imageKey
  if (analysisQueue.request?.imageKey) {
    // Pass the analysis queue record as-is, CloudFrontImageField will handle the request.imageKey extraction
    return <CloudFrontImageField source="request" record={analysisQueue} />;
  }

  return <div></div>;
};

const DocumentShowActions = () => <TopToolbar>{/* Add edit button or other actions here if needed */}</TopToolbar>;

export const DocumentShow = () => {
  const translate = useTranslate();

  return (
    <Show title={translate('form_submission.show.title')} actions={<DocumentShowActions />}>
      <SimpleShowLayout>
        <TextField source="id" />
        <DateField source="created_at" showTime />
        <DateField source="updated_at" showTime />
        <ReferenceField
          source="form_template_id"
          reference="form_template"
          label={translate('form_submission.fields.template_name')}
        >
          <TextField source="name" />
        </ReferenceField>
        {/* Image from analysis queue */}
        <FunctionField label={translate('form_submission.fields.image')} render={() => <AnalysisQueueImage />} />
        <FunctionField
          label={translate('form_submission.fields.submitted_data')}
          render={(record: any) => {
            const expected_data = record?.expected_data;
            if (expected_data && typeof expected_data === 'object') {
              return <ReactJson src={expected_data} collapsed={true} />;
            }
            if (expected_data) {
              return <pre>{JSON.stringify(expected_data, null, 2)}</pre>;
            }
            return <div>{translate('ra.page.empty')}</div>;
          }}
        />
        <TextField source="note" />
      </SimpleShowLayout>
    </Show>
  );
};

export default DocumentShow;
